import { Command } from '@theia/core';

export const LVGL_COMMAND_CATEGORY = 'LVGL';

export type TemplateRoot = 'components' | 'screens' | 'widgets' | 'tests';

export const TEMPLATE_ROOTS: readonly TemplateRoot[] = ['components', 'screens', 'widgets', 'tests'];

export namespace TemplateCreateCommands {
    export const NEW_SCREEN: Command = Command.toLocalizedCommand(
        {
            id: 'lvgl:create-screen',
            category: LVGL_COMMAND_CATEGORY,
            label: 'Create New Screen'
        },
        'lvgl/navigator/createScreen',
        LVGL_COMMAND_CATEGORY
    );

    export const NEW_COMPONENT: Command = Command.toLocalizedCommand(
        {
            id: 'lvgl:create-component',
            category: LVGL_COMMAND_CATEGORY,
            label: 'Create New Component'
        },
        'lvgl/navigator/createComponent',
        LVGL_COMMAND_CATEGORY
    );

    export const NEW_WIDGET: Command = Command.toLocalizedCommand(
        {
            id: 'lvgl:create-widget',
            category: LVGL_COMMAND_CATEGORY,
            label: 'Create New Widget'
        },
        'lvgl/navigator/createWidget',
        LVGL_COMMAND_CATEGORY
    );

    export const NEW_TEST: Command = Command.toLocalizedCommand(
        {
            id: 'lvgl:create-test',
            category: LVGL_COMMAND_CATEGORY,
            label: 'Create New Test'
        },
        'lvgl/navigator/createTest',
        LVGL_COMMAND_CATEGORY
    );
}

export const TEMPLATE_CREATE_COMMAND_BY_ROOT: Record<TemplateRoot, Command> = {
    screens: TemplateCreateCommands.NEW_SCREEN,
    components: TemplateCreateCommands.NEW_COMPONENT,
    widgets: TemplateCreateCommands.NEW_WIDGET,
    tests: TemplateCreateCommands.NEW_TEST
};
